import { useEffect, useState } from "react";

export const CONTENT_ENTER_ANIMATION_CLASSNAME = "duration-300 ease-out animate-in fade-in-0";
export const CHILD_CONTENT_ENTER_ANIMATION_CLASSNAME =
  "[&>*]:duration-300 [&>*]:ease-out [&>*]:animate-in [&>*]:fade-in-0";

/** Enables enter animations briefly after mount so virtualized items loaded later do not animate. */
export const useInitialEnterAnimation = (activeMs = 400) => {
  const [shouldAnimateIn, setShouldAnimateIn] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShouldAnimateIn(false), activeMs);
    return () => clearTimeout(timer);
  }, [activeMs]);

  return shouldAnimateIn;
};
